import templateUrl from './other-form.html';

export default {
  templateUrl,
  bindings: {
    adverseEvent: '<',
    locked: '<'
  },
  controller: class OtherFormComponent {
    constructor() {
      'ngInject';
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/adverse-event/other-form/other-form.component.js